import React from "react";
import { Box, Dialog, DialogContent, DialogTitle, Grid, Paper, Typography } from "@mui/material";
import PropTypes from "prop-types";
import SlideUpTransition from "../fundamentals/SlideUpTransition";
import StarsCloseIconButton from "../fundamentals/StarsCloseIconButton.jsx";
import { getStationTimeZoneDateTimeStringFromUTCInteger } from "../../util/timeZoneService.js";

const BidGroupEmpAuditHistoryDialog = (props) => {
  const handleClickDialogClose = () => {
    props.setEmployee(null);
  };

  const prepareTitle = () => {
    return props.employee && `${props.employee?.eid} | ${props.employee?.lastName}, ${props.employee?.shortName}`;
  };

  const getAuditEventType = (event) => {
    if (event.isRemoved) {
      return "Removed";
    }

    if (event.isEligible) {
      return "Eligible";
    }

    return "Ineligible";
  };

  return (
    <Dialog
      className="detail-dialog"
      open={!!props.employee}
      TransitionComponent={SlideUpTransition}
      keepMounted
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        sx: {
          minHeight: "10vh",
          minWidth: "30vw",
        },
      }}
    >
      <DialogTitle>
        <StarsCloseIconButton onClick={handleClickDialogClose} />
        <Box
          sx={{
            overflowWrap: "break-word",
            marginTop: "20px",
          }}
          className="detail-dialog-section-title"
        >
          {prepareTitle()}
        </Box>
      </DialogTitle>
      <DialogContent className="detail-dialog-content">
        <Grid container>
          <Grid item xs={12}>
            {props.employee?.comments && Array.isArray(props.employee?.comments) && props.employee.comments.length > 0
              ? props.employee.comments.map((event, index) => {
                  return (
                    <Paper
                      key={index}
                      sx={{
                        padding: "15px 20px",
                        marginBottom: "10px",
                      }}
                      elevation={3}
                    >
                      <Grid container>
                        <Grid item container xs={12}>
                          <Grid item xs={8}>
                            <Typography
                              sx={{
                                overflowWrap: "break-word",
                              }}
                            >
                              {getStationTimeZoneDateTimeStringFromUTCInteger(
                                event.createdAt,
                                props.bid.station
                              ).toFormat("MM/dd/yyyy T ZZZZ")}
                              {`, ${event.createdBy}`}
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <b>Rank: {event.rank}</b>
                          </Grid>
                          <Grid
                            item
                            xs={2}
                            sx={{
                              color: getAuditEventType(event) !== "Eligible" ? "primary.swaRed" : "primary.swaBlue",
                            }}
                          >
                            <b>{getAuditEventType(event)}</b>
                          </Grid>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography sx={{ color: "primary.swaBlue", overflowWrap: "break-word" }}>
                            {event.comments}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Paper>
                  );
                })
              : "No events found"}
          </Grid>
        </Grid>
      </DialogContent>
    </Dialog>
  );
};

BidGroupEmpAuditHistoryDialog.propTypes = {
  bid: PropTypes.object.isRequired,
  employee: PropTypes.object,
  setEmployee: PropTypes.func.isRequired,
};

export default BidGroupEmpAuditHistoryDialog;
